import Select, { SelectProps, InlineSelect } from "./Select";
import { withLabel } from "composants/withLabel";

export const SysDomaineAndLabel = withLabel<SelectProps>()(Select);

export const InlineSelectAndLabel = withLabel<SelectProps>()(InlineSelect);

export default SysDomaineAndLabel;
